import {
  USER_INDEX,
  WORKSPACE_GROUP_INDEX,
} from "@/components/pieces/algolia/indexes";

export interface UserGroupFilter {
  selections?: Array<{ id: string }>;
  workspaceId?: string;
  userId?: string;
  isWorkspaceAdmin?: boolean;
}

export const buildUserGroupFilters = ({
  selections = [],
  workspaceId,
  userId,
  isWorkspaceAdmin = false,
}: UserGroupFilter = {}): Record<string, string> => {
  const selectionFilters = selections
    .map((item) => `NOT objectID:${item.id}`)
    .join(" AND ");

  let workspaceGroupFilters: string[] = [];
  let userFilters: string[] = [];

  if (workspaceId) {
    workspaceGroupFilters.push(`workspace_id:${workspaceId}`);
    userFilters.push(`workspace_${workspaceId}`);
  }

  if (userId && !isWorkspaceAdmin) {
    workspaceGroupFilters.push(`user_${userId}`);
  }

  return {
    [USER_INDEX]: [selectionFilters, ...userFilters]
      .filter(Boolean)
      .join(" AND "),
    [WORKSPACE_GROUP_INDEX]: [selectionFilters, ...workspaceGroupFilters]
      .filter(Boolean)
      .join(" AND "),
  };
};
